import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
    Text,
    Title,
    Avatar,
    GridContainer,
    GridItem,
    Tag,
    ContainedButton,
    FileIcon,
    HorizontalRule,
    StyledCard,
    StyledCardContent,
    TextField,
} from '../../index';

const HomeworkCard = ({ data, onDetail, onChange }) => {
    const theme = useTheme();

    return (
        <StyledCard padding="0">
            <StyledCardContent>
                <div
                    style={{
                        display: 'flex',
                        padding: '10px',
                        background:
                            'linear-gradient(263.61deg, #FFFFFF 15.63%, rgba(255, 255, 255, 0.5) 94.52%)',
                        border: `1px solid ${theme.palette.common.gray6}`,
                        boxShadow: '0px 2px 4px rgba(132, 140, 183, 0.05)',
                    }}
                >
                    <div>
                        {data ? (
                            <Avatar
                                alt={data?.patient?.user?.fullname}
                                src={data?.patient?.user?.avatar?.url}
                                $avatarSize="48px"
                            />
                        ) : (
                            <Skeleton variant="rect" width={64} height={64} />
                        )}
                    </div>
                    <div style={{ display: 'flex', flexGrow: 1 }}>
                        <GridContainer style={{ paddingLeft: '10px', width: '250px' }}>
                            <GridItem justifyContent="flex-start">
                                {data ? (
                                    <Title
                                        style={{
                                            fontSize: '16px',
                                        }}
                                        $ellipsis
                                        $lineHeight="20px"
                                    >
                                        {data?.patient?.user?.fullname}
                                    </Title>
                                ) : (
                                    <Skeleton width={200} height={30} variant="text" />
                                )}
                            </GridItem>
                            <GridItem
                                justifyContent="flex-start"
                                style={{ alignSelf: 'flex-end', display: 'flex', columnGap: '5px' }}
                            >
                                {data ? (
                                    !_.isEmpty(data?.patient?.patientTag) &&
                                    data.patient.patientTag.map((tag) => <Tag key={tag}>{tag}</Tag>)
                                ) : (
                                    <Skeleton
                                        width={70}
                                        height={30}
                                        variant="text"
                                        style={{ marginRight: '10px' }}
                                    />
                                )}
                            </GridItem>
                        </GridContainer>
                    </div>
                    <div>
                        <ContainedButton
                            $icon
                            style={{ width: '24px', height: '24px' }}
                            onClick={() => onDetail(data?.patient?.id)}
                        >
                            <FileIcon />
                        </ContainedButton>
                    </div>
                </div>
                <div
                    style={{
                        padding: '10px 15px 15px',
                    }}
                >
                    <Text $bold $fontSize="12px" style={{ marginBottom: '10px' }}>
                        Note to client
                    </Text>
                    <TextField
                        id="note"
                        name="note"
                        placeholder="Note To Client"
                        minRows={3}
                        value={data.note}
                        onChange={(e) => onChange(e, data.id)}
                        helperText={data.errors.find((value) => value.property === 'note')?.message}
                        inputProps={{ maxLength: 2000 }}
                    />
                </div>
                <HorizontalRule />
                <div
                    style={{
                        padding: '10px 15px 15px',
                    }}
                >
                    <Text $bold $fontSize="12px" style={{ marginBottom: '10px' }}>
                        Homework
                    </Text>
                    <TextField
                        id="homework"
                        name="homework"
                        placeholder="Homework"
                        minRows={3}
                        value={data.homework}
                        onChange={(e) => onChange(e, data.id)}
                        helperText={
                            data.errors.find((value) => value.property === 'homework')?.message
                        }
                        inputProps={{ maxLength: 2000 }}
                    />
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

HomeworkCard.propTypes = {
    data: PropTypes.object.isRequired,
    onDetail: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default HomeworkCard;
